<template>
  <TableStyleWrapper>
    <TableWrapper class="table-responsive">
      <a-table
          :loading="loadingTemplates"
          :dataSource="templateTableData"
          :columns="templateTableColumns"
          :pagination="{
          pageSize: tablePageSize,
          showSizeChanger: true,
          total: count,
          current: currentPage,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${count} items`,
        }"
          @change="paginationChange"
      />
    </TableWrapper>
  </TableStyleWrapper>
</template>
<script>
import {TableStyleWrapper} from '../style';
import {TableWrapper} from '../../styled';
import {computed, defineComponent} from 'vue';
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import moment from "moment";
import {useAbility} from "@casl/vue";

const templateTableColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Naam',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Aangemaakt op',
    dataIndex: 'createTimestamp',
    key: 'createTimestamp',
  },
  {
    title: 'Actions',
    dataIndex: 'action',
    key: 'action',
    width: '90px',
  },
];
const TemplateTable = defineComponent({
  name: 'TemplateTable',
  components: {TableStyleWrapper, TableWrapper},
  setup() {
    const router = useRouter();
    const {state, dispatch} = useStore();
  const tablePageSize = computed(() => state.productCommunicationTemplate.pageSize);
    const {matched} = useRoute();
    const {path} = matched[1];
    const templates = computed(() => state.productCommunicationTemplate.templates);
    const loadingTemplates = computed(() => state.productCommunicationTemplate.loadingTemplates);
    const currentPage = computed(() => state.productCommunicationTemplate.currentPage);
    const count = computed(() => state.productCommunicationTemplate.count);
    const { can } = useAbility();
    const handleDelete = async (id) => {
      await dispatch('deleteTemplate', id);
      await dispatch('getTemplates', {page: state.productCommunicationTemplate.currentPage, pageSize: state.productCommunicationTemplate.pageSize});
    };
    const handleEdit = (id) => {
      router.push(`${path}/${id}`);
    };
    const templateTableData = computed(() =>
        templates.value.map((template) => {
          const {id, name, type, createTimestamp} = template;

          return {
            key: id,
            id: id,
            name: <span>{name}</span>,
            type: <span>{type === 'EMAIL' ? 'Email' : 'PDF'}</span>,
            createTimestamp: <span>{moment(createTimestamp).format('DD-MM-YYYY HH:mm:ss')}</span>,
            action: (
                <div className="table-actions">
                  {can('view', 'productcommunicationtemplate') ? (
                      <sdButton onClick={() => handleEdit(id)} className="btn-icon" to="#" type="default" shape="circle">
                        <sdFeatherIcons type="edit" size="16"/>
                      </sdButton>
                  ) : ('')}
                  {can('delete', 'productcommunicationtemplate') ? (
                      <a-popconfirm
                          title="Weet je het zeker? U kunt dit niet meer terugdraaien!"
                          ok-text="Ja"
                          cancel-text="Nee"
                          placement="leftTop"
                          onConfirm={() => handleDelete(id)}
                      >
                        <sdButton className="btn-icon" type="default" to="#" shape="circle">
                          <sdFeatherIcons type="trash-2" size="16"/>
                        </sdButton>
                      </a-popconfirm>
                  ) : ('')}
                </div>
            ),
          };
        }),
    );

    const paginationChange = async (event) => {
      await dispatch('setCurrentPageTemplates', event.current);
      await dispatch('getTemplates', {page: event.current, pageSize: event.pageSize});
    }

    return {tablePageSize, templateTableColumns, templateTableData, loadingTemplates, paginationChange, count, currentPage};
  },
});

export default TemplateTable;
</script>

